export const PRODUCTS = Object.freeze({
    BETTER_ENERGY: "BETTER_ENERGY",
} as const);

export const PRODUCT_MODULES = Object.freeze({
    BETTER_CONTROL: "BETTER_CONTROL",
    BETTER_MONITOR: "BETTER_MONITOR",
    BETTER_ANALYZE: "BETTER_ANALYZE",
} as const);

export const PRODUCT_PACKAGES = Object.freeze({
    BETTER_ANALYZE_BASIC: "BETTER_ANALYZE_BASIC",
    BETTER_ANALYZE_PREMIUM: "BETTER_ANALYZE_PREMIUM",
    BETTER_ANALYZE_ENTERPRISE: "BETTER_ANALYZE_ENTERPRISE",
} as const);

export const FEATURES = Object.freeze({
    PREHEATING_EARLYCHECKOUT: "PREHEATING_EARLYCHECKOUT",
} as const);
